// extracted by mini-css-extract-plugin
module.exports = {"container":"BackButton_container__-kd5l","icon":"BackButton_icon__Ipu7D"};